




import Vue from 'vue';

import { getConfig } from '@/web/utils/configuration';

export default Vue.extend({
  data() {
    return {
      logo: getConfig()['admin-icon-logo'],
    };
  },
});
